import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignItems", "children", "flexRef", "horizontalGap", "justify", "verticalGap"];
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toPx } from '../utils/Styles';
import { BASE_SPACING_X, BASE_SPACING_Y, GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import UIFlex from './UIFlex';
import refObject from '../utils/propTypes/refObject';
import { ALIGN_OPTIONS, JUSTIFY_OPTIONS } from './FlexConstants';

/** @internal */

/** @internal */
import { jsx as _jsx } from "react/jsx-runtime";
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UIButtonWrapper__FlexContainer",
  componentId: "sc-15li3m6-0"
})(["margin-left:-", ";margin-top:-", ";max-width:none;width:auto;@media only screen and (max-width:", "){flex-grow:1;}&&& > *{margin-left:", ";margin-top:", ";}"], props => toPx(props.horizontalGap), props => toPx(props.verticalGap), GRID_BREAKPOINT_SMALL, props => toPx(props.horizontalGap), props => toPx(props.verticalGap));
const UIButtonWrapper = props => {
  const {
      alignItems,
      children,
      flexRef,
      horizontalGap,
      justify,
      verticalGap
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(FlexContainer, {
      align: alignItems,
      horizontalGap: horizontalGap,
      justify: justify,
      ref: flexRef,
      verticalGap: verticalGap,
      wrap: "wrap",
      children: children
    })
  }));
};
UIButtonWrapper.propTypes = {
  alignItems: PropTypes.oneOf(Object.keys(ALIGN_OPTIONS)),
  children: PropTypes.node,
  flexRef: refObject,
  justify: PropTypes.oneOf(Object.keys(JUSTIFY_OPTIONS)),
  horizontalGap: PropTypes.number,
  verticalGap: PropTypes.number
};
UIButtonWrapper.defaultProps = {
  alignItems: 'center',
  horizontalGap: parseInt(BASE_SPACING_X, 10),
  verticalGap: parseInt(BASE_SPACING_Y, 10)
};
UIButtonWrapper.displayName = 'UIButtonWrapper';
export default UIButtonWrapper;